export default __webpack_public_path__ + "static/media/frieslandLogo.dbdf28c4.png";